import type { GameSession } from './session';
import type { Hud } from './ui/hud';

export const runtime: {
  session: GameSession | null;
  hud: Hud | null;
} = {
  session: null,
  hud: null,
};
